import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AdminApp from './admin/App';
import CustomerApp from './customer/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const App = process.env.REACT_APP_TARGET === 'admin' ? AdminApp : CustomerApp;

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
